import { Pratica } from '../../interfaces/pratica';
import { Impresa } from '../applicant/models/impresa';
import { LiberoProfessionista } from '../applicant/models/libero-professionista';
import { Soggetto } from '../anagraphics/models/cms-document-fields';
import { PersonaGiuridica } from '../applicant/models/persona-giuridica';
import { ExecuteScoreResponse } from './execute-score-response';

export interface IPropostaIndicativa {
  codiceFiscale: string;
  commissioniCanale: number;
  dataOra: string;
  durataInMesi: string;
  frequenzaPagamento: number;
  idPraticaSpin: string;
  importoRichiesto: number;
  mesiPreammortamento: number;
  naturaGiuridica: string;
  ragioneSociale: string;
  scoreCrif: string;
  tassoParametro: string;
  tipoProdotto: string;
  tipoSoggetto: Soggetto;
  tipoContabilita: PersonaGiuridica['tipoContabilita'];

  codiceAteco: string;
  idPraticaOutsystems: string;
  idProdotto: string;
  mesiAmmortamento: string;
  nomeProdotto: string;
  pIva: string;
}

export class PropostaIndicativa {
  static createProposalBody(
    score: ExecuteScoreResponse,
    pratica: Pratica,
    personaGiuridica: PersonaGiuridica | Impresa | LiberoProfessionista,
    commissioni: number | undefined
  ) {
    let proposal: IPropostaIndicativa = {
      codiceFiscale: pratica.piva,
      commissioniCanale: commissioni || 0,
      frequenzaPagamento:
        PropostaIndicativa.frequenza[score.data.periodicitaRate],
      idPraticaSpin: pratica.praticaCode,
      ragioneSociale: personaGiuridica.denominazione,
      scoreCrif: score.score?.class || '',
      naturaGiuridica: personaGiuridica.formaGiuridica || '',
      tassoParametro: score.data.tasso,
      tipoProdotto: score.tipoProdotto,
      tipoSoggetto: personaGiuridica.tipoSoggetto,
      tipoContabilita: personaGiuridica.tipoContabilita,
      dataOra: new Date().toISOString(),
      durataInMesi: score.data.durata,

      importoRichiesto: score.importo || 0,
      mesiPreammortamento: score.data.preammortamento,
      idPraticaOutsystems: score.pricing?.Id_Pratica_Outsystems || '',

      codiceAteco: (personaGiuridica as Impresa).ateco,
      idProdotto: score.id,
      mesiAmmortamento: score.data.durata,
      nomeProdotto: score.tipoProdotto,
      pIva: personaGiuridica.partitaIva,
    };

    return proposal;
  }

  static frequenza: Record<
    NonNullable<ExecuteScoreResponse['data']['periodicitaRate']>,
    number
  > = {
    M: 1,
  };
}
